import type { MonthlyShiftSlotSummaryRepository, MonthlyShiftSlotSummaryListResult } from './ports/MonthlyShiftSlotSummaryRepository';

/**
 * 月次シフト枠サマリー一覧取得UseCaseの入力パラメータ
 *
 * @property {number} [page] - 取得するページ番号（省略時は1）
 * @property {number} [pageSize] - 1ページあたりの件数（省略時は50）
 */
export interface GetMonthlyShiftSlotSummaryListInput {
  page?: number;
  pageSize?: number;
}

/**
 * 月次シフト枠サマリー一覧取得UseCaseの出力結果
 *
 * @property {MonthlyShiftSlotSummaryListResult} result - ページネーション付きサマリー一覧
 */
export interface GetMonthlyShiftSlotSummaryListOutput {
  result: MonthlyShiftSlotSummaryListResult;
}

/**
 * 月次シフト枠サマリー一覧を取得するUseCase
 *
 * @description
 * 月次シフト枠管理ページの一覧表示に使用する。
 * ページネーション対応で、年月降順でソートされたデータを返す。
 *
 * @param {MonthlyShiftSlotSummaryRepository} repository - Repository実装（DI）
 * @param {GetMonthlyShiftSlotSummaryListInput} input - 入力パラメータ
 * @returns {Promise<GetMonthlyShiftSlotSummaryListOutput>} ページネーション付きサマリー一覧
 *
 * @example
 * const { result } = await getMonthlyShiftSlotSummaryList(repository, { page: 1, pageSize: 50 });
 * console.log(result.data); // MonthlyShiftSlotSummary[]
 * console.log(result.meta.total); // 総件数
 */
export async function getMonthlyShiftSlotSummaryList(
  repository: MonthlyShiftSlotSummaryRepository,
  input: GetMonthlyShiftSlotSummaryListInput
): Promise<GetMonthlyShiftSlotSummaryListOutput> {
  const result = await repository.findAll({
    page: input.page,
    pageSize: input.pageSize
  });

  return { result };
}
